import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { withRouter } from 'react-router';
import v from 'validate.js';
import styles from './style.module.css';
import * as Routes from '../../../../../constants/routes';
import { trackingEvent } from '../../../../../helpers/tracking';
import { onSubmit } from '../../../../../common/components/submit-button';
import logger from '../../../../../helpers/logger';

export const formName = Routes.STEPTHREE;

const tracking = {
    eventAction: 'Mortgage Calculator - Step 3',
    eventLabel: 'Down Payment'
};

const validate = values => v(values, {
    creditScore: {
        presence: {
            allowEmpty: false,
            message: 'is required'
        }
    }
});

const creditScoreOptions = [
    { value: 'below-650', label: 'Below 650' },
    { value: '651-700', label: '651-700' },
    { value: '701-760', label: '701-760' },
    { value: '761+', label: '761+' },
    { value: 'not-sure', label: "I'm Not Sure" }
];

const CreditScorePills = ({ input, meta: { error, submitFailed } }) => (
    <div>
        <div className={styles.pillContainer} role='radiogroup' aria-label='Credit score range'>
            <div className={styles.pillRow}>
                {creditScoreOptions.slice(0, 4).map(option => (
                    <button
                        key={option.value}
                        type='button'
                        role='radio'
                        aria-checked={input.value === option.value}
                        className={input.value === option.value ? styles.pillActive : styles.pill}
                        onClick={() => {
                            logger.logUserAction('credit_score_selected', 'MortgageCalculator-Step3', {
                                step: 3,
                                selectedValue: option.value,
                                selectedLabel: option.label,
                                previousValue: input.value
                            });
                            input.onChange(option.value);
                        }}
                    >
                        {option.label}
                    </button>
                ))}
            </div>
            <div className={styles.pillRow}>
                {creditScoreOptions.slice(4).map(option => (
                    <button
                        key={option.value}
                        type='button'
                        role='radio'
                        aria-checked={input.value === option.value}
                        className={input.value === option.value ? styles.pillActive : styles.pill}
                        onClick={() => {
                            logger.logUserAction('credit_score_selected', 'MortgageCalculator-Step3', {
                                step: 3,
                                selectedValue: option.value,
                                selectedLabel: option.label,
                                previousValue: input.value
                            });
                            input.onChange(option.value);
                        }}
                    >
                        {option.label}
                    </button>
                ))}
            </div>
        </div>
        {submitFailed && error && error.map((message, i) =>
            <span key={i} className={styles.errorMessage} role='alert'>{message}</span>
        )}
    </div>
);

class StepThreeForm extends Component {
    componentDidUpdate(prevProps) {
        // Log validation errors
        if (this.props.invalid && this.props.submitFailed && this.props.syncErrors) {
            logger.warn('Form validation failed in Step 3', {
                step: 3,
                formName: formName,
                errors: this.props.syncErrors,
                values: this.props.values
            });
        }
    }

    render() {
        return (
            <form className={styles.form}>
                <label className={styles.label}>Choose your range below</label>
                <Field
                    name='creditScore'
                    component={CreditScorePills}
                />
            </form>
        );
    }
}

// Enhanced onSubmit with logging
const enhancedOnSubmit = async (values, dispatch, props) => {
    try {
        const result = await onSubmit(values, dispatch, props);
        logger.logFormSubmission('MortgageCalculator-Step3', values, true);
        return result;
    } catch (error) {
        logger.error('Step 3 form submission failed', {
            step: 3,
            formName: formName,
            values,
            error: error.message || error
        });
        throw error;
    }
};

StepThreeForm = reduxForm({
    form: formName,
    destroyOnUnmount: false,
    validate,
    onSubmit: enhancedOnSubmit,
    initialValues: {},
    redirectPath: `/mortgage${Routes.STEPFOUR}`,
    tracking: () => trackingEvent(tracking)
})(StepThreeForm);

export default withRouter(StepThreeForm);
